// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopOrderPagingResultModel from '../../model/shop-order-paging-result-model';
import ShopOrderPagingResultDTO from '../dto/shop-order-paging-result-dto';
import dtoSchema from '../schemas/shop-order-paging-result-schema';
import ShopOrderModel from '../../model/shop-order-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class ShopOrderPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopOrderPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ShopOrderModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: ShopOrderModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<ShopOrderPagingResultDTO>): ShopOrderPagingResultModel;
  static toModel(dto: DeepPartial<ShopOrderPagingResultDTO> | undefined | null): ShopOrderPagingResultModel | undefined;
  static toModel(dto: DeepPartial<ShopOrderPagingResultDTO> | undefined | null): ShopOrderPagingResultModel | undefined {
    return dto ? new ShopOrderPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopOrderPagingResultModel> | ShopOrderPagingResultModel): ShopOrderPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as ShopOrderPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopOrderPagingResultModel, can not map to ShopOrderPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
